import { Injectable, signal } from '@angular/core';

export type DrawingMode = 'virtual-fence' | 'distance-measurement' | null;

@Injectable({ providedIn: 'root' })
export class DrawingManagerService {
  readonly activeDrawingMode = signal<DrawingMode>(null);

  setActiveDrawingMode(mode: DrawingMode) {
    this.activeDrawingMode.set(mode);
  }
}
